module.exports = __webpack_public_path__ + "img/IMG_6984_L_BlackMatted.1491b5b4.jpg";